"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _chart = _interopRequireDefault(require("chart.js"));

var _reactRouterDom = require("react-router-dom");

var _index = require("../../index");

var _UserModel = _interopRequireDefault(require("../users/all-users/models/UserModel"));

var _AppBadge = _interopRequireDefault(require("../../components/elements/icon/AppBadge"));

var _components = require("../../components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DashboardPage = /*#__PURE__*/function (_Component) {
  _inherits(DashboardPage, _Component);

  function DashboardPage(props) {
    var _this;

    _classCallCheck(this, DashboardPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DashboardPage).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_tableComponent", void 0);

    _this.state = {
      loading: false,
      totalProjects: 5,
      lastWeek: 10,
      lastMonth: 14,
      lastYear: 29,
      topSchools: [],
      data: [],
      schoolNames: [],
      labels: ["1", "2", "3", "4", "5", "6", "7"]
    };
    return _this;
  }

  _createClass(DashboardPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _chart["default"].defaults.global.defaultFontColor = 'white';
      this.renderOrderDotsChart();
      var color = _chart["default"].helpers.color;
      var config = {
        type: 'pie',
        cutoutPercentage: 0,
        data: {
          datasets: [{
            data: [12, 19],
            backgroundColor: ['rgba(124, 197, 118, 1)', 'rgba(54, 162, 235, 1)'],
            borderColor: ['rgba(89, 97, 107, 1)', 'rgba(89, 97, 107, 1)'],
            label: 'Dataset 1'
          }],
          labels: ["Orange", "Red"]
        },
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          legend: {
            fullWidth: true,
            display: true,
            labels: {
              fontColor: '#fff'
            }
          }
        }
      };
      var config2 = {
        type: 'doughnut',
        cutoutPercentage: 20,
        data: {
          datasets: [{
            data: [12, 19],
            backgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)'],
            borderColor: ['rgba(89, 97, 107, 1)', 'rgba(89, 97, 107, 1)'],
            label: 'Dataset 1'
          }],
          labels: ["Red", "Orange"]
        },
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          legend: {
            fullWidth: true,
            display: true,
            labels: {
              fontColor: '#fff'
            }
          }
        }
      };
      var barChartConfig = {
        type: 'bar',
        data: {
          labels: ["8/2018", "9/2018", "10/2018", "11/2018", "12/2018", "1/2019"],
          datasets: [{
            label: '# of Votes',
            data: [400, 1000, 2500, 2300, 3000, 3250],
            backgroundColor: ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(153, 102, 255, 0.2)', 'rgba(255, 159, 64, 0.2)'],
            borderColor: ['rgba(255,99,132,1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)'],
            borderWidth: 1
          }]
        },
        options: {
          legend: {
            display: false
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            yAxes: [{
              gridLines: {
                color: 'rgba(255, 255, 255, 0.1)'
              },
              ticks: {
                beginAtZero: true
              }
            }],
            xAxes: [{
              gridLines: {
                color: 'rgba(255, 255, 255, 0.1)'
              },
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      };
      var ctx33 = document.getElementById("barChartConfig");

      if (ctx3) {
        var ctx3 = ctx33.getContext("2d");
        window.barChartConfig = new _chart["default"](ctx3, barChartConfig);
      }
    }
    /**
     * Render customer chart
     */

  }, {
    key: "renderCustomerChart",
    value: function renderCustomerChart() {
      var ctxx = document.getElementById("customerChart");
      var ctx = ctxx.getContext("2d");
      var customerChartData = {
        // labels: this.getAllSchools(),
        datasets: [{
          label: "Total collected £",
          // data: this.getAllSchoolsData(),
          backgroundColor: "rgba(54, 162, 235, 1)",
          hoverBackgroundColor: "#66A2EB"
        }]
      };
      var customerChart = new _chart["default"](ctx, {
        type: 'horizontalBar',
        data: customerChartData,
        options: {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(255, 255, 255, 0.1)'
              },
              ticks: {
                beginAtZero: true
              }
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(255, 255, 255, 0.1)'
              },
              stacked: true
            }]
          }
        }
      });
    }
  }, {
    key: "renderOrderDotsChart",
    value: function renderOrderDotsChart() {
      var config = {
        type: 'line',
        data: {
          labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [{
            label: "Orders",
            data: [600, 500, 600, 1000, 1500, 1200, 1100, 1250, 1500, 2000, 1800, 2000],
            backgroundColor: 'rgba(54, 162, 235, 1)',
            borderColor: 'rgba(54, 162, 235, 0.4)',
            pointBorderColor: 'rgba(255, 255, 255, 1)',
            borderWidth: 2,
            fill: false,
            showLine: true,
            borderDash: [2],
            pointRadius: 6,
            pointHoverRadius: 10
          }]
        },
        options: {
          responsive: true,
          legend: {
            display: false
          },
          hover: {
            mode: 'index'
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(255, 255, 255, 0.1)'
              },
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Month'
              }
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(255, 255, 255, 0.1)'
              },
              ticks: {
                max: 2200
              },
              display: true,
              scaleLabel: {
                display: false
              }
            }]
          }
        }
      };
      var ctxy = document.getElementById("chart-dots");

      if (ctxy) {
        var ctx = ctxy.getContext("2d");
        window.myScatter = new _chart["default"](ctx, config);
      }
    }
  }, {
    key: "_renderStatus",
    value: function _renderStatus(item) {
      switch (item.kycStatus) {
        case 'approved':
          return _react["default"].createElement(_AppBadge["default"], {
            text: "Approved",
            icon: "check"
          });

        case 'declined':
          return _react["default"].createElement(_AppBadge["default"], {
            text: "Declined",
            icon: "times",
            type: "danger"
          });

        case 'pending_review':
          return _react["default"].createElement(_AppBadge["default"], {
            text: "Pending review",
            icon: "clock-o",
            type: "info"
          });

        case 'document_review_in_progress':
          return _react["default"].createElement(_AppBadge["default"], {
            text: "Document review in progress",
            icon: "clock-o",
            type: "info"
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "dashboard-management"
      }, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-tachometer",
        "aria-hidden": "true"
      }), " Dashboard"), _react["default"].createElement("div", {
        className: "main-inner",
        style: {
          paddingBottom: 20
        }
      }, _react["default"].createElement(_components.LPOverridable, {
        name: "pages.home.widgets.top"
      }, _react["default"].createElement("div", {
        className: "widget"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "widget-header"
      }, _react["default"].createElement("h3", {
        className: "widget-title"
      }, _react["default"].createElement("i", {
        className: "fa fa-users",
        "aria-hidden": "true"
      }), " New Users")), _react["default"].createElement("div", {
        className: "widget-inner"
      }, _react["default"].createElement("div", {
        className: "widget-new-customers"
      }, _react["default"].createElement("i", {
        className: "fa fa-users",
        "aria-hidden": "true"
      }), _react["default"].createElement("p", {
        className: "customers-number"
      }, this.state.totalProjects, " ", _react["default"].createElement("span", null, "total users")), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, "Last week"), _react["default"].createElement("li", null, " ", this.state.lastWeek)), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, "Last month"), _react["default"].createElement("li", null, " ", this.state.lastMonth)), _react["default"].createElement("ul", null, _react["default"].createElement("li", null, "Last year"), _react["default"].createElement("li", null, " ", this.state.lastYear))))), _react["default"].createElement("div", {
        className: "widget"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "widget-header"
      }, _react["default"].createElement("h3", {
        className: "widget-title"
      }, _react["default"].createElement("i", {
        className: "fa fa-bar-chart",
        "aria-hidden": "true"
      }), " New users")), _react["default"].createElement("div", {
        className: "widget-inner",
        style: {
          padding: '10px'
        }
      }, _react["default"].createElement("div", null, _react["default"].createElement("canvas", {
        id: "chart-dots",
        style: {
          width: '100%',
          height: '300px'
        },
        width: "600",
        height: "300"
      })))), _react["default"].createElement("div", {
        className: "widget"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "widget-header"
      }, _react["default"].createElement("h3", {
        className: "widget-title"
      }, _react["default"].createElement("i", {
        className: "fa fa-bar-chart",
        "aria-hidden": "true"
      }), " Transactions")), _react["default"].createElement("div", {
        className: "widget-inner",
        style: {
          padding: '10px'
        }
      }, _react["default"].createElement("div", {
        style: {
          width: '100%',
          height: '100%'
        }
      }, _react["default"].createElement("canvas", {
        id: "barChartConfig",
        style: {
          width: '100%',
          height: '300px'
        },
        width: "600",
        height: "300"
      })))))), _react["default"].createElement(_components.LPOverridable, {
        name: "pages.home.widgets.bottom"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-lg-6"
      }, _react["default"].createElement("div", {
        className: "activated-cards"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-users"
      }), " Latest Users"), _react["default"].createElement("div", {
        className: "box-header-action"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/users/all-users",
        className: "button"
      }, "List all"))), _react["default"].createElement("div", {
        className: "box-body"
      }, _react["default"].createElement(_index.AppTable, {
        title: null,
        onInit: function onInit(tableComponent) {
          return _this2._tableComponent = tableComponent;
        },
        filter: null,
        paginate: false,
        params: {
          limit: 10
        },
        parseUrl: false,
        order: [{
          field: 'id',
          direction: 'desc'
        }],
        model: _UserModel["default"],
        renderCell: function renderCell(column, item, index) {
          switch (column.name) {
            case 'kycStatus':
              return _this2._renderStatus(item);
          }
        },
        getColumnActions: function getColumnActions(member, index) {
          return _react["default"].createElement("div", null, _react["default"].createElement(_reactRouterDom.Link, {
            to: "/users/all-users/details/".concat(member.id),
            className: "button-info"
          }, "Details"));
        }
      })))), _react["default"].createElement("div", {
        className: "col-lg-6"
      }, _react["default"].createElement("div", {
        className: "activated-cards"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-users"
      }), " Latest Account Verifications"), _react["default"].createElement("div", {
        className: "box-header-action"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/users/all-users",
        className: "button"
      }, "List all"))), _react["default"].createElement("div", {
        className: "box-body"
      }, _react["default"].createElement("table", {
        className: "table"
      }, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", {
        className: "tr-dark-bg"
      }, _react["default"].createElement("td", {
        style: {
          width: '10%'
        }
      }, "Id"), _react["default"].createElement("td", null, "Name"), _react["default"].createElement("td", null, "Customer ID"), _react["default"].createElement("td", null, "Status"), _react["default"].createElement("td", {
        align: "center",
        style: {
          width: '20%'
        }
      }, "Actions")), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "532"), _react["default"].createElement("td", null, "John Doe"), _react["default"].createElement("td", null, "165864549"), _react["default"].createElement("td", null, _react["default"].createElement("span", {
        className: "badge badge-success"
      }, _react["default"].createElement("i", {
        className: "fa fa-check"
      }), "  Approved")), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "531"), _react["default"].createElement("td", null, "John Doe"), _react["default"].createElement("td", null, "165864549"), _react["default"].createElement("td", null, _react["default"].createElement("span", {
        className: "badge badge-success"
      }, _react["default"].createElement("i", {
        className: "fa fa-check"
      }), "  Approved")), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "529"), _react["default"].createElement("td", null, "John Doe"), _react["default"].createElement("td", null, "165864549"), _react["default"].createElement("td", null, _react["default"].createElement("span", {
        className: "badge badge-danger"
      }, _react["default"].createElement("i", {
        className: "fa fa-check"
      }), "  Approved")), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "528"), _react["default"].createElement("td", null, "John Doe"), _react["default"].createElement("td", null, "165864549"), _react["default"].createElement("td", null, _react["default"].createElement("span", {
        className: "badge badge-success"
      }, _react["default"].createElement("i", {
        className: "fa fa-check"
      }), "  Approved")), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "525"), _react["default"].createElement("td", null, "John Doe"), _react["default"].createElement("td", null, "165864549"), _react["default"].createElement("td", null, _react["default"].createElement("span", {
        className: "badge badge-success"
      }, _react["default"].createElement("i", {
        className: "fa fa-check"
      }), "  Approved")), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details"))), _react["default"].createElement("tr", null, _react["default"].createElement("td", null, "524"), _react["default"].createElement("td", null, "John Doe"), _react["default"].createElement("td", null, "165864549"), _react["default"].createElement("td", null, _react["default"].createElement("span", {
        className: "badge badge-success"
      }, _react["default"].createElement("i", {
        className: "fa fa-check"
      }), "  Approved")), _react["default"].createElement("td", {
        align: "center"
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/push-notifications/push-details",
        className: "button-info"
      }, "Details")))))))))));
    }
  }]);

  return DashboardPage;
}(_react.Component);

exports["default"] = DashboardPage;